module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Media/Next-c998734b21877c635512a352462dbe90.svg";